import { L2_PATHS, staticRoutes } from 'Deer/constants/routes';
import { NotificationSettingsIntent } from 'Deer/intent/Settings/Notification/NotificationSettingsIntent';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import { useHistory } from 'react-router-dom';

const NOTIFICATION_BREADCRUMBS = {
  items: [
    {
      label: 'Company',
      to: L2_PATHS.company.overview,
    },
  ],
  page: {
    label: 'Notifications',
    to: '',
  },
};

const NotificationSettingsIntentDropdown = () => {
  const history = useHistory();

  const NOTIFICATION_SETTINGS_INTENT = [
    {
      label: 'Settings',
      visible: () => true,
      onClick: () => {
        history.push(staticRoutes.company.settings.platform.notifications);
      },
      category: 'NOTIFICATION',
    },
  ];

  return (
    <IntentFilters
      intentDropdownOptions={NOTIFICATION_SETTINGS_INTENT}
      selectedIntent={NOTIFICATION_SETTINGS_INTENT[0].label}
      moduleName="settings"
      breadcrumbs={NOTIFICATION_BREADCRUMBS}
      intentTitle="Notifications"
    />
  );
};

export const NotificationSettings = ({ isEmployeeNotificationSettings = false }) => (
  <Layout Filters={<NotificationSettingsIntentDropdown />}>
    <NotificationSettingsIntent isEmployeeNotificationSettings={isEmployeeNotificationSettings} />
  </Layout>
);
